var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon16(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.09,
    height: 44.09,
    viewBox: "0 0 44.09 44.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(-1053 -641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M21.086,4.631a5.57,5.57,0,0,0-7.879,0L12.133,5.7,11.06,4.631A5.571,5.571,0,0,0,3.181,12.51l1.074,1.073,7.879,7.879,7.879-7.879,1.074-1.073a5.57,5.57,0,0,0,0-7.879Z",
    transform: "translate(1064.414 650.637)",
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "message-circle",
    d: "M44.09,22.4a19.13,19.13,0,0,1-2.055,8.675A19.4,19.4,0,0,1,24.686,41.807a19.13,19.13,0,0,1-8.675-2.055L3,44.09,7.337,31.078A19.13,19.13,0,0,1,5.283,22.4,19.4,19.4,0,0,1,16.012,5.055,19.13,19.13,0,0,1,24.686,3h1.141A19.358,19.358,0,0,1,44.09,21.262Z",
    transform: "translate(1051.5 639.5)",
    fill: "none",
    stroke: "#f59e0b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon16);
export default __webpack_public_path__ + "static/media/media_icon16.7f2beeb32a40d53938064a9331648c63.svg";
export { ForwardRef as ReactComponent };